module.exports = __webpack_public_path__ + "img/logo.c7bc1800.png";